const joinStatus = {

	/**
	 * Stripe subscription id's.
	 *
	 * @type {string}
	 */
	subscription_id_monthly: 'price_1LuXayJnethvgku8wokbzUhK', // $7 a month.
	// subscription_id_yearly: 'price_1LuXayJnethvgku80FJu1UpB', // $49 a year.
	subscription_id_yearly: 'price_1MoNqUJnethvgku8CvHZFfU2', // $48 a year.
	// subscription_lifetime: 'price_1OTt1dJnethvgku8VSLcWnmD', // $69 lifetime.

	subscription_id_monthly_test: 'price_1Lu1thJnethvgku8smP2EFI7',
	subscription_id_yearly_test: 'price_1Lu1thJnethvgku8fFOKPLGi',
	// subscription_lifetime_test: 'price_1QO6DZJnethvgku8Rk3mbIXp',


	/**
	 * Store the reef app for this component.
	 *
	 * @type {object}
	 */
	app: undefined,


	/**
	 * Initialize the component.
	 */
	init: function() {

		const $comp = document.getElementById( 'join-status' );

		if ( !$comp ) {
			return;
		}

		joinStatus.app = new Reef(
			$comp,
			{
				data: members.app.data,
				template: joinStatus.template,
				attachTo: [ members.app ]
			}
		);

		members.app.render();

		$comp.addEventListener( 'click', joinStatus.click );

	},


	/**
	 * Define the template for the component.
	 *
	 * @param {object} props The component properties.
	 * @return {string}
	 */
	template: function( props ) {

		// Display only for users who are paid subscribers.
		if ( members.isSubscriber() ) {
			return joinStatus.userLoggedIn( props );
		}

		// Display for everyone else.
		return joinStatus.joinButtons( props );

	},


	/**
	 * Display useful links for subscribed users.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	userLoggedIn: function( props ) {

		return `
		<div class="position-s p4 bg-yellow b-br2">
			<h3 class="m-b3">Useful Links</h3>
			<ul>
				<li><a href="${ninja_props.stripe_account}">Manage/ Cancel Subscription</a></li>
				<li><a href="/members/animations/">Download Animation Files</a></li>
				<li><a href="/members/image-archive/">Image Archive Files</a></li>
				<li><a href="/members/contact/">Priority Contact</a></li>
				<li><a href="/members/roadmap/">Brush Ninja Roadmap</a></li>
				<li><a href="/members/profile/">Edit Profile</a></li>
			</ul>
		</div>
		`;

	},


	/**
	 * Buttons for logged out users, prompting to sign up.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	joinButtons: function( props ) {

		// console.log( window.location.host );
		let sub_monthly = joinStatus.subscription_id_monthly;
		let sub_yearly = joinStatus.subscription_id_yearly;
		// let sub_lifetime = joinStatus.subscription_lifetime;

		console.log( 'host', window.location.host );

		if ( members.isLocal() ) {
			// console.log( 'Test URL' );
			sub_monthly = joinStatus.subscription_id_monthly_test;
			sub_yearly = joinStatus.subscription_id_yearly_test;
			// sub_lifetime = joinStatus.subscription_lifetime_test;
		}

		// <div class="button-description">
		// 	<a
		// 		href="#"
		// 		class="button secondary"
		// 		id="signup-lifetime"
		// 		data-id="${sub_lifetime}"
		// 	>Join for ${ninja_props.price_lifetime} One time &rarr;</a>
		// 	<p>BEST VALUE!</p>
		// </div>

		return `
		<div class="position-s grid p-t4">
			<div class="button-description">
				<a
					href="#"
					class="button"
					id="signup-yearly"
					data-id="${sub_yearly}"
				>Join for ${ninja_props.price_yearly} a year &rarr;</a>
				<p>$4 A MONTH!</p>
			</div>
			<a
				href="#"
				class="button"
				id="signup-monthly"
				data-id="${sub_monthly}"
			>Join for ${ninja_props.price_monthly} a month &rarr;</a>

			<img src="/assets/images/cc/group.png" alt="Credit Card Logos" class="o60 p-x3 o100__hover" />

			<div class="o60 o100__hover t-ta-c f5">
				<p>All payments include a 7-day refund period. You can cancel subscriptions at any time. <a href="/terms-and-conditions/#refunds-and-cancellations">Full Terms & Conditions</a>.</p>
			</div>
		</div>`;

	},

};
const loginform = {


	STATE_LOGIN: 1,
	STATE_FORGOT_PASSWORD: 2,

	/**
	 * Store the reef app for this component.
	 *
	 * @type {object}
	 */
	app: undefined,

	/**
	 * Store the login modal.
	 *
	 * @type {object}
	 */
	login_modal: undefined,


	initialized: false,


	/**
	 * Initialize the component.
	 */
	init: function() {

		if ( loginform.initialized ) {
			return;
		}

		loginform.initialized = true;

		loginform.app = new Reef(
			null,
			{
				data: {
					mode: loginform.STATE_LOGIN
				},
				lagoon: true,
			}
		);

	},


	/**
	 * Display the login modal.
	 *
	 * @return {void}
	 */
	display: function() {

		loginform.login_modal = modal.showGeneral( 'Login' );
		loginform.login_modal.innerHTML = loginform.template();
		loginform.login_modal.addEventListener( 'click', loginform.click );

	},


	/**
	 * Define the template for the component.
	 *
	 * @param {object} props The component properties.
	 * @return {string}
	 */
	template: function() {

		const props = loginform.app.data;

		console.log( loginform.app );
		if ( loginform.STATE_FORGOT_PASSWORD === props.state ) {
			return loginform.forgotPasswordTemplate( props );
		}
		return loginform.loginTemplate( props );

	},


	/**
	 * Display the forgot password template.
	 *
	 * @param {object} props The template properties.
	 * @return {string}
	 */
	forgotPasswordTemplate: function( props ) {

		return `
		<h3>Request Temporary Password</h3>
		<form id="login-form" method="POST">

			<label for="login-username">Username</label>
			<input id="login-username" name="login-username" type="text" autocomplete="username" required>

			<div id="login-error" class="p3 bg-red b-br1 f-fw600 m-b4 display-none"></div>

			<input type="submit" value="Request Password" id="submit-password-request" class="button">

		</form>
		<p class="f-fw500"><a href="#login" id="back-to-login">&larr; Back to login</a></p>
		`;
	},


	/**
	 * Display the login template.
	 *
	 * @param {object} props The template properties.
	 * @return {string}
	 */
	loginTemplate: function( props ) {

		return `
		<form id="login-form" method="POST">

			<label for="login-username">Username</label>
			<input id="login-username" name="login-username" type="text" autocomplete="username" required>

			<label for="login-password">Password</label>
			<input id="login-password" name="login-password" type="password" autocomplete="current-password" required placeholder="Password">

			<div id="login-error" class="p3 bg-red b-br2 f-fw600 m-b4 display-none"></div>

			<input type="submit" value="Sign in" id="submit-login" class="button">

		</form>
		<p class="f-fw500">
			<a href="#forgotpassword" id="login-forgot-password">Forgot Password</a>
			<span class="m-x3 o30">|</span>
			<a href="/join/">Need an account? Join &rarr;</a>
		</p>
		`;

	},


	/**
	 * Handle user login.
	 *
	 * @param {object} e The click event.
	 * @return {void}
	 */
	handleLogin: function( e ) {

		const login_username = document.getElementById( 'login-username' );
		const login_password = document.getElementById( 'login-password' );
		const login_error = document.getElementById( 'login-error' );
		const username = login_username.value;
		const password = login_password.value;

		login_error.classList.add( 'display-none' );

		members.setUserLoading();

		userbase.signIn(
			{
				username,
				password,
				rememberMe: 'local'
			}
		)
			.then(
				( user ) => {
					modal.close();
					members.setUserLoggedIn( user );
				}
			)
			.catch(
				( e ) => {
					members.resetUserLogStatus();
					members.errorDisplay( e, 'login-error' );
				}
			);

	},


	/**
	 * Handle password request.
	 *
	 * @param {object} e The click event.
	 * @return {void}
	 */
	handlePasswordRequest: function( e ) {

		const login_username = document.getElementById( 'login-username' );
		const username = login_username.value;

		userbase.forgotPassword(
			{
				username
			}
		)
			.then(
				() => {
					loginform.app.setData( { state: loginform.STATE_LOGIN } );
					modal.close();
					alert( 'Password Request sent. Check your email.' );
				}
			)
			.catch(
				( e ) => {
					members.errorDisplay( e, 'login-error' );
				}
			);

	},


	/**
	 * Click action for the component.
	 *
	 * @param {object} e Event.
	 * @return {void}
	 */
	click: function( e ) {

		const target = e.target;
		const id = target.id;

		// console.log( id );

		if ( 'submit-login' === id ) {

			e.preventDefault();

			loginform.handleLogin( e );

			members.disableButton( target );

		}

		if ( 'submit-password-request' === id ) {

			e.preventDefault();

			loginform.handlePasswordRequest();

			members.disableButton( target );

		}

		if ( 'login-forgot-password' === id ) {

			e.preventDefault();

			loginform.app.setData( { state: loginform.STATE_FORGOT_PASSWORD } );
			loginform.login_modal.innerHTML = loginform.template();

		}

		if ( 'back-to-login' === id ) {

			e.preventDefault();

			loginform.app.setData( { state: loginform.STATE_LOGIN } );
			loginform.login_modal.innerHTML = loginform.template();

		}

	},

};
/**
 * Take care of the login component.
 */
const members = {

	/**
	 * Member status constants.
	 *
	 * @type {string}
	 */
	STATUS_LOADING: 'loading',
	STATUS_LOGGEDIN: 'loggedin',
	STATUS_LOGGEDOUT: 'loggedout',


	/**
	 * The ID for the signup banner that goes showed and hidden based upon the users state.
	 *
	 * @type {string}
	 */
	SIGNUP_BANNER: 'user-signup-banner',


	/**
	 * Userbase APPID.
	 *
	 * @type {string}
	 */
	APP_ID: '4a9f69ba-2527-42cc-a577-e89253d81bc4',
	APP_ID_TEST: '98122218-b0b7-443f-8d3b-763625df5059',


	/**
	 * The url prefix for beta testing.
	 *
	 * @type {string}
	 */
	TESTURL: 'brush-ninja--beta',


	/**
	 * The CDN url for downloading animations.
	 *
	 * @type {string}
	 */
	DOWNLOW_URL: 'https://files.brush.ninja/animations',


	/**
	 * The Reef app object.
	 *
	 * @var {object}
	 */
	app: null,


	/**
	 * Initialize the component.
	 *
	 * @return {void}
	 */
	init: function() {

		console.log( 'members.init' );
		members.checkUserbase();

	},


	/**
	 * Check if userbase is loaded.
	 * If not then wait a bit and try again.
	 *
	 * @return {void}
	 */
	checkUserbase: function() {

		if ( !members.userbaseEnabled() ) {
			setTimeout( members.checkUserbase, 150 );
		} else {
			console.log( 'userbase loaded' );
			members.userbaseInit();
		}

	},


	/**
	 * Initialize userbase.
	 *
	 * @return {void}
	 */
	userbaseInit: function() {

		members.init_nav();

		let app_id = members.APP_ID;

		if ( members.isLocal() ) {
			app_id = members.APP_ID_TEST;
		}

		userbase.init( { appId: app_id } )
			.then(
				( session ) => {
					if ( session.user ) {
						members.setUserLoggedIn( session.user );
					} else {
						members.setUserLoggedOut( session.user );
					}
					document.querySelector( 'body' ).classList.remove( 'members-loading' );
				}
			);

	},


	/**
	 * Initialize the navigation.
	 *
	 * @return {void}
	 */
	init_nav: function() {

		const $navWrapper = document.querySelector( '.nav-members' );

		if ( !$navWrapper ) {
			return;
		}

		// Userbase isn't defined so must be offline.
		if ( !members.userbaseEnabled() ) {
			$navWrapper.remove();
			return;
		}

		// Create the Reef app.
		// Separate from the other apps since it works on every page.
		members.app = new Reef(
			$navWrapper,
			{
				data: {
					status: members.STATUS_LOADING,
					member: null,
				},
				template: members.template,
			}
		);

		// Init MemberStack.
		members.app.render();

		$navWrapper.addEventListener( 'click', members.handleNavClick );

	},


	/**
	 * Is the current environment localhost?
	 *
	 * @return {boolean}
	 */
	isLocal: function() {

		return window.location.href.includes( 'localhost' );

	},


	/**
	 * Handle user navigation clicks.
	 *
	 * @param {object} e The click event.
	 * @return {void}
	 */
	handleNavClick: function( e ) {

		const target = e.target.getAttribute( 'href' );

		if ( !target ) {
			return;
		}

		if ( target.startsWith( '/#/ms/' ) ) {
			e.preventDefault();
			e.stopPropagation();
		}

		// Logout.
		if ( '/#/ms/logout' === target ) {

			members.setUserLoading();

			userbase.signOut()
				.then(
					( session ) => {
						members.setUserLoggedOut();
					}
				);

		}

		// Login.
		if ( '/#/ms/login' === target ) {

			loginform.display();

		}

	},


	/**
	 * User data changing so display loading bar.
	 *
	 * @return {void}
	 */
	setUserLoading: function() {

		if ( !members.app ) {
			return;
		}

		members.app.setData(
			{
				status: members.STATUS_LOADING,
				member: undefined
			}
		);

	},


	/**
	 * User logged in so update state.
	 *
	 * @param {object} user The user that has logged in.
	 * @return {void}
	 */
	setUserLoggedIn: function( user ) {

		if ( members.app ) {
			members.app.setData(
				{
					status: members.STATUS_LOGGEDIN,
					member: user
				}
			);
		}

		ninjaEvent( 'login-status-change' );

		/**
		 * If the user is not a subscriber, but IS a registered user then
		 * display the signup banner.
		 */
		if ( !members.isSubscriber() ) {

			const $signupBanner = document.getElementById( members.SIGNUP_BANNER );

			if ( $signupBanner ) {
				$signupBanner.classList.add( 'display-block' )
				$signupBanner.classList.remove( 'display-none' );
			}

		} else {

			document.querySelector( 'body' ).classList.add( 'members-subscribed' );

		}

	},


	/**
	 * User logged out so update state.
	 *
	 * @param {object} user The logged out user properties.
	 * @return {void}
	 */
	setUserLoggedOut: function( user = undefined ) {

		if ( members.app ) {
			members.app.setData(
				{
					status: members.STATUS_LOGGEDOUT,
					member: user
				}
			);
		}

		ninjaEvent( 'login-status-change' );

		/**
		 * Hide the signup banner.
		 */
		const $signupBanner = document.getElementById( members.SIGNUP_BANNER );
		if ( $signupBanner ) {
			$signupBanner.classList.add( 'display-none' );
			$signupBanner.classList.remove( 'display-block' );
		}

		document.querySelector( 'body' ).classList.remove( 'members-subscribed' );

	},


	/**
	 * Set user navigation to the last known state based on whether the user is
	 * logged in or not.
	 *
	 * @return {void}
	 */
	resetUserLogStatus: function() {

		if ( !members.app ) {
			return;
		}

		const user = members.app.data.member;

		if ( user ) {
			members.setUserLoggedIn( user );
		} else {
			members.setUserLoggedOut( user );
		}

	},


	/**
	 * The template for the component.
	 *
	 * @param {object} props The template properties.
	 * @return {string}
	 */
	template: function( props ) {

		// Shared link CSS class.
		const linkClass = 'flex-g1 p2 p-x3 b-br2 bg-blue';

		let html = '';

		switch ( props.status ) {

			case members.STATUS_LOADING:

				html += `<div class="loading__small w4"></div>`;

				break;

			case members.STATUS_LOGGEDIN:

				console.log( members.app.data.member );
				// ${props.member.username}

				html += `
				<a class="${linkClass}" href="/members/profile/?tok=${props.member.username}" title="Edit Profile">Profile</a>
				<a class="${linkClass} flex flex-ai-c" href="/#/ms/logout" title="Logout">
					<span class="screen-reader-text">Logout</span>
					<img src="/assets/images/button-logout.svg" class="pe-none" alt="*" />
				</a>
				`;

				break;

			case members.STATUS_LOGGEDOUT:
			default:

				html += `
				<a class="${linkClass} flex gap1" href="/join/"><span class="icon-premium"></span> Join</a>
				<a class="${linkClass}" href="/#/ms/login">Login</a>
				`;

				break;

		}

		return html;

	},


	/**
	 * Is the current user a logged in member or not?
	 *
	 * @return {boolean}
	 */
	loggedIn: function() {

		// Userbase isn't defined so must be offline.
		if ( !members.userbaseEnabled() ) {
			return false;
		}

		// Display premium features on firebase test url.
		if ( window.location.href.includes( members.TESTURL ) ) {
			console.log( 'login fb test' );
			return true;
		}

		if ( !members.app ) {
			return false;
		}

		// Get user data.
		const member = members.app.data.member;

		if ( !member ) {
			return false;
		}

		// Allow the binarymoon account to test paid memberships.
		const testname = "bi" + 'na' + 'rymo' + `on`;
		if ( testname === member[ `us${'er' + 'na'}` + `me` ] ) {
			console.log( 'admin user logged in' );
			return true;
		}

		// If the member is active then they have a valid subscription.
		if ( 'active' === member.subscriptionStatus ) {
			console.log( 'user logged in' );
			return true;
		}

		return false;

	},


	/**
	 * Is the user a paid subscriber?
	 *
	 * @return {boolean}
	 */
	isSubscriber: function() {

		return members.loggedIn();

	},


	/**
	 * Is the user a premium member?
	 * Just a wrapper for isSubscriber (and convenience).
	 *
	 * @return {boolean}
	 */
	isPremium: function() {

		return members.loggdIn();

	},


	/**
	 * Is userbase enabled.
	 * Will be false if the user is offline.
	 *
	 * @return {boolean}
	 */
	userbaseEnabled: function() {

		const defined = 'undefined' === typeof userbase;
		return !defined;

	},


	/**
	 * Get the user data for the logged in user.
	 *
	 * @return {object} The logged in users info.
	 */
	memberData: function() {

		return members.app.data;

	},


	/**
	 * Initialize CDN downloads.
	 *
	 * @param {string} selector The DOM string that will select the links that need updating.
	 * @return {null}
	 */
	init_downlow: function( selector = null ) {

		if ( !selector ) {
			return;
		}

		const links = document.querySelectorAll( selector );

		if ( links.length < 1 ) {
			return;
		}

		links.forEach(
			element => {

				element.addEventListener(
					'click',
					( e ) => {
						members.downlow( e );
					}
				);

			}
		);

	},


	/**
	 * Download a file from S3, checking the user is logged in before we do so.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	downlow: function( e ) {

		// Don't let free users download the animations.
		if ( !members.isSubscriber() ) {
			alert( 'Files are for subscribed users. Subscribe to get access to the image downloads.' );
			return;
		}

		if ( !e ) {
			return;
		}

		const target = e.target;
		const download_id = target.getAttribute( 'data-dl' );
		// console.log( download_id );

		if ( !download_id ) {
			return;
		}

		const filename = download_id + '.brushninja';
		const url = members.DOWNLOW_URL + '/' + filename;

		// console.log( filename );

		downloadLink( filename, url );

	},


	/**
	 * Display a userbase error message in the specified div.
	 *
	 * @param {object} message The error object.
	 * @param {string} id The id of the div to place the error in. Does not need the #.
	 * @return {void}
	 */
	errorDisplay: function( message, id ) {

		/**
		 * Convert the object that only holds a string, into a string that can
		 * be edited.
		 */
		message = message + '';
		// Grab the error element.
		const error_message = document.getElementById( id );
		if ( !error_message ) {
			return;
		}
		// Display the error element.
		error_message.classList.remove( 'display-none' );
		// Display the error, splitting the error code off of the front.
		let message_parts = message.split( ':' );
		if ( message_parts[ 1 ] ) {
			message = message_parts[ 1 ];
		}
		error_message.innerHTML = message;

	},


	/**
	 * Disable a button temporarily.
	 *
	 * @param {object} target The button to disable.
	 * @return {void}
	 */
	disableButton: function( target ) {

		const currentHtml = target.getAttribute( 'value' );
		// Disable button.
		target.setAttribute( 'disabled', 'disabled' );
		target.setAttribute( 'value', 'Processing...' );

		setTimeout(
			() => {
				target.removeAttribute( 'disabled' );
				target.setAttribute( 'value', currentHtml );
			},
			5000
		);

	}

};



const membersOnly = {

	/**
	 * Template to use to push people to sign up.
	 *
	 * @type {string}
	 */
	TEMPLATE: `<div class="p4 b-br2 bg-yellow f4">
	This content is for premium members. <a href="/join/">Become a member</a> or <a href="#/ms/login/" class="login-prompt">Login</a> to get full access.</div>`,


	/**
	 * Template to refresh the page.
	 *
	 * @type {string}
	 */
	TEMPLATE_REFRESH: `<div class="p4 b-br2 bg-yellow f4">
	Logged in. Refresh the page to update the content.</div>`,


	/**
	 * Initialise members only content.
	 */
	init: function() {

		// membersOnly.setLoading();

		/**
		 * Only check the content once we know if the user is logged in or not.
		 */
		document.addEventListener(
			'login-status-change',
			() => {
				console.log( 'login status change' );
				membersOnly.checkContent();
				membersOnly.hideAds();
			}
		);

		const containers = membersOnly.getContainers();
		containers.forEach(
			( e ) => {
				e.addEventListener(
					'click',
					membersOnly.clickEvent
				);
			}
		);

	},


	/**
	 * Set the loading bar.
	 *
	 * @return {void}
	 */
	setLoading: function() {

		const containers = membersOnly.getContainers();

		containers.forEach(
			( e ) => { e.classList.add( 'loading' ); }
		);

	},


	/**
	 * Container click event.
	 *
	 * @param {event} e The event properties.
	 * @return {void}
	 */
	clickEvent: function( e ) {

		if ( e.target.classList.contains( 'login-prompt' ) ) {

			e.preventDefault();
			e.stopPropagation();
			loginform.display();
			return;

		}

	},


	/**
	 * Check if the content can be hidden or not.
	 *
	 * @return {void}
	 */
	checkContent: function() {

		if ( ninja_props && true === ninja_props.members ) {
			if ( !members.isSubscriber() ) {
				membersOnly.hideContent();
			}
		}

		membersOnly.showContainers();

	},


	/**
	 * Hide page content if the container exists.
	 *
	 * @return {void}
	 */
	hideContent: function() {

		const containers = membersOnly.getContainers();

		containers.forEach(
			( e ) => { e.innerHTML = membersOnly.TEMPLATE; }
		);

	},


	/**
	 * Containers are hidden when the page.members is true. This will show them
	 * again.
	 * They are hidden to prevent a flash of content if the javascript has yet
	 * to execute (which is likely).
	 * The content is hidden using css in _includes/script-vars.html
	 *
	 * @return  {void}
	 */
	showContainers: function() {

		const containers = membersOnly.getContainers();

		containers.forEach(
			( e ) => {
				e.classList.add( 'display-block' );
			}
		);

	},


	/**
	 * Get a list of content containers.
	 *
	 * @return {object}
	 */
	getContainers: function() {

		return document.querySelectorAll( '.container' );

	},


	/**
	 * Hide ads for logged in members.
	 *
	 * @return {void}
	 */
	hideAds: function() {

		if ( !members.isSubscriber() ) {
			return;
		}

		const $adWrappers = document.querySelectorAll( '.as-wrapper' );

		if ( !$adWrappers ) {
			return;
		}

		$adWrappers.forEach(
			( e ) => {
				e.innerHTML = '';
			}
		);

	},

};

const membersProfile = {

	/**
	 * Store the reef app for this component.
	 *
	 * @type {object}
	 */
	app: undefined,


	/**
	 * Initialize the component.
	 */
	init: function() {

		const $comp = document.getElementById( 'profile-edit' );

		// Quit because there's no space to edit the profile.
		if ( !$comp ) {
			return;
		}

		membersProfile.app = new Reef(
			$comp,
			{
				data: members.app.data,
				template: membersProfile.template,
				attachTo: [ members.app ]
			}
		);

		members.app.render();

		$comp.addEventListener( 'click', membersProfile.click );

	},


	/**
	 * Define the template for the component.
	 *
	 * @param {object} props The component properties.
	 * @return {string}
	 */
	template: function( props ) {

		const user = props.member;

		// No user so display a logged out message.
		if ( !user ) {
			return `<div class="p4 bg-red b-br2 f-fw500"><a href="/join/">Login or Join Brush Ninja</a> to access this page.</div>`;
		}

		// Check email is defined.
		let user_email = user.email;
		if ( undefined === user_email ) {
			user_email = '';
		}

		// Logged in so display a form for editing the profile.
		return `
		<form id="signup-form" method="POST">
			<label for="profile-username">Login Username</label>
			<input id="profile-username" name="profile-username" disabled type="text" value="${sanitize.attr( user.username )}">

			<label for="profile-email">Email <small>Only used to reset your password</small></label>
			<input id="profile-email" name="profile-email" type="email" value="${sanitize.attr( user_email )}" required minLength="6">

			<fieldset>
				<legend>Update Password</legend>
				<label for="profile-password">Password</label>
				<input id="profile-password" name="profile-password" type="password" placeholder="Password">

				<label for="new-profile-password">New Password</label>
				<input id="new-profile-password" name="new-profile-password" type="password" placeholder="New Password">
			</fieldset>

			<div id="edit-profile-error" class="p3 bg-red b-br2 f-fw600 m-b4 display-none"></div>

			<input type="submit" id="submit-profile" value="Update Profile" class="button">
		</form>
		`;

	},


	/**
	 * Update the user data.
	 *
	 * @return {void}
	 */
	update: function() {

		const input_email = document.getElementById( 'profile-email' );
		const input_password = document.getElementById( 'profile-password' );
		const input_new_password = document.getElementById( 'new-profile-password' );

		const currentPassword = input_password.value;
		const newPassword = input_new_password.value;
		const email = input_email.value;

		let settings = {};
		settings.email = email;

		if ( newPassword || currentPassword ) {
			settings.currentPassword = currentPassword;
			settings.newPassword = newPassword;
		}

		userbase.updateUser( settings )
			.then(
				() => {
					// Is this needed?
					// members.app.render();

					alert( 'Your profile has been updated.' );
				}
			)
			.catch(
				( e ) => {
					members.errorDisplay( e, 'edit-profile-error' );
				}
			);

	},


	/**
	 * Click action for the component.
	 *
	 * @param {object} e Event.
	 * @return {void}
	 */
	click: function( e ) {

		const target = e.target;
		const id = target.id;

		if ( 'submit-profile' === id ) {

			e.preventDefault();
			membersProfile.update();

			members.disableButton( target );

		}

	},

};
const signupform = {


	/**
	 * Store the reef app for this component.
	 *
	 * @type {object}
	 */
	app: undefined,


	/**
	 * The id for the price plan to charge for.
	 *
	 * @type {string}
	 */
	price_plan: '',


	initialized: false,


	/**
	 * Initialize the component.
	 */
	init: function() {

		if ( signupform.initialized ) {
			return;
		}

		signupform.initialized = true;

		signupform.app = new Reef(
			null,
			{
				data: {},
				template: signupform.template,
				lagoon: true,
			}
		);

		// React to the relevant join buttons in the sidebar.
		document.getElementById( 'join-status' ).addEventListener( 'click', signupform.signupButton );

	},


	/**
	 * What happens when you click the signup button on the join page.
	 *
	 * @param {object} e The click event.
	 * @return {void}
	 */
	signupButton: function( e ) {

		const user = members.app.data.member;

		// Reset the price id so we don't run the wrong one by accident.
		signupform.price_plan = '';

		// Get the payment product.
		const price = e.target.getAttribute( 'data-id' );

		if ( !price ) {
			return;
		} else {
			signupform.price_plan = price;
		}

		e.preventDefault();

		if ( !user ) {
			signupform.display( e.target );
			return;
		}

		signupform.newSubscription( user );

	},


	/**
	 * Load the payment page.
	 *
	 * @param {object} user The current user information.
	 * @return {void}
	 */
	newSubscription: function( user ) {

		console.log( 'user', user );

		// Make sure they don't have a subscription already.
		if ( user.subscriptionStatus ) {
			return;
		}

		// Make sure a subscription plan is set.
		if ( !signupform.price_plan ) {
			return;
		}

		// Redirect to the join page.
		const join_url = window.location.origin + '/join/';

		// https://twitter.com/UserbaseHQ/status/1261471331154931712/photo/2
		userbase.purchaseSubscription(
			{
				successUrl: join_url + '?success',
				cancelUrl: join_url + '?cancel',
				priceId: signupform.price_plan
			}
		)
			.then( () => { } )
			.catch( ( e ) => console.error( e ) );

	},


	/**
	 * Display the signup form.
	 *
	 * @return {void}
	 */
	display: function( target ) {

		let title = 'Join Brush Ninja';
		let description = target.innerHTML
			.replace( '&rarr;', '' )
			.replace( '→', '' )
			.trim();

		signupform.signup_modal = modal.showGeneral( title );
		signupform.signup_modal.innerHTML = signupform.template( description );

		signupform.signup_modal.addEventListener( 'click', signupform.click );
		signupform.signup_modal.addEventListener( 'change', signupform.blur );

	},


	/**
	 * Define the template for the component.
	 *
	 * @param {object} props The component properties.
	 * @return {string}
	 */
	template: function( description ) {

		const props = signupform.app.data;

		return `
		<p class="f4 f-fw900 fg-yellow">${description}</p>
		<form id="signup-form" method="POST">
			<label for="signup-username">Username</label>
			<input id="signup-username" name="signup-username" type="text" required autocomplete="username">

			<label for="signup-email">Email <small>Used for resetting passwords only.</small></label>
			<input id="signup-email" name="signup-email" type="email" required minLength="6" autocomplete="off">

			<label for="signup-password">Password</label>
			<input id="signup-password" name="signup-password" type="password" required placeholder="Password" autocomplete="new-password">

			<label class="m-b4">
				<input type="checkbox" name="terms-and-conditions-agreed" required />
				I have read and agree to the Brush Ninja <a href="/terms-and-conditions/" target="_blank">Terms and Conditions</a>
			</label>

			<div id="signup-error" class="p3 bg-red b-br1 f-fw600 m-b4 display-none"></div>

			<p class="p3 bg-green b-br1"><strong>Please note:</strong> Premium features will be unlocked once payment has completed.</p>

			<input type="submit" id="input-signup" value="Signup and pay" class="button">

			<p class="m-y3 f-fw500"><a href="/privacy-policy/" target="_blank">Privacy Policy &rarr;</a></p>
		</form>
		`;

	},


	/**
	 * Process the user sign up.
	 *
	 * @param {object} e The click event.
	 * @return {void}
	 */
	handleSignUp: function( e ) {

		const input_username = document.getElementById( 'signup-username' );
		const input_password = document.getElementById( 'signup-password' );
		const input_email = document.getElementById( 'signup-email' );

		// Get terms checkbox value.
		const terms = document.querySelector( 'input[name="terms-and-conditions-agreed"]' ).checked;

		if ( !terms ) {
			members.errorDisplay( 'Please agree to the terms and conditions.', 'signup-error' );
			return false;
		}

		const username = input_username.value;
		const password = input_password.value;
		const email = input_email.value;

		members.setUserLoading();

		let settings = { username, password, rememberMe: 'local' };
		// Only include email if it's set. This prevents the email being saved as 'undefined'.
		if ( email ) {
			settings.email = email;
		}

		userbase.signUp( settings )
			.then(
				( user ) => {
					modal.close();
					members.setUserLoggedIn( user );
					signupform.newSubscription( user );
				}
			)
			.catch(
				( e ) => {
					members.resetUserLogStatus();
					members.errorDisplay( e, 'signup-error' );
				}
			);

	},



	/**
	 * Click action for the component.
	 *
	 * @param {object} e Event.
	 * @return {void}
	 */
	click: function( e ) {

		const target = e.target;
		const id = target.id;

		if ( 'input-signup' === id ) {

			e.preventDefault();
			signupform.handleSignUp();

		}

	},


	/**
	 * Blur action for the component.
	 */
	blur: function( e ) {

		// console.log( 'blur', e );

		const blocked = [ 'csisd.org' ];

		const email = document.getElementById( 'signup-email' ).value;

		// If email contains text from blocked array, show error.
		if ( blocked.some( domain => email.includes( domain ) ) ) {
			document.getElementById( 'input-signup' ).setAttribute( 'disabled', 'disabled' );
			members.errorDisplay( 'Error with this email address.', 'signup-error' );
		} else {
			document.getElementById( 'input-signup' ).removeAttribute( 'disabled' );
		}

	},

};





; ( function() {

	'use strict';

	ready(
		function() {

			members.init();
			membersProfile.init();
			membersOnly.init();
			loginform.init();
			joinStatus.init();

			// If signup page.
			if ( document.body.classList.contains( 'page-join' ) ) {
				signupform.init();
			}

		}
	);

} )();
